import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ReelConfig {
  url: string;
  embedUrl: string;
  title?: string;
  thumbnail?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FloatingReelService {
  private readonly homeReelUrl = 'https://www.instagram.com/reel/DPhylf1DRf5/?igsh=bGg4MDl3cHNuY3U1';
  private readonly productReelUrl = 'https://www.instagram.com/reel/DPYXAd4Dbty/?igsh=MWswc3RpZWNkdXhmcQ==';
  
  private currentReelSubject = new BehaviorSubject<ReelConfig | null>(null);
  public currentReel$ = this.currentReelSubject.asObservable();

  constructor() {}

  setReelForRoute(url: string): void {
    const isProductPage = url.includes('/product/') && !url.includes('/products');
    const reelUrl = isProductPage ? this.productReelUrl : this.homeReelUrl;
    
    const reelConfig: ReelConfig = {
      url: reelUrl,
      embedUrl: this.convertToEmbedUrl(reelUrl),
      title: isProductPage ? 'Product Demo' : 'Home Introduction'
    };
    
    this.currentReelSubject.next(reelConfig);
  }

  private convertToEmbedUrl(instagramUrl: string): string {
    // Extract reel ID from Instagram URL
    const reelId = instagramUrl.split('/reel/')[1]?.split('/')[0];
    if (reelId) {
      // Enhanced parameters to ensure consistent behavior and remove unwanted buttons
      return `https://www.instagram.com/p/${reelId}/embed/?autoplay=1&controls=1&rel=0&show_comments=0&show_user=0&show_reel=1`;
    }
    return '';
  }

  getCurrentReel(): ReelConfig | null {
    return this.currentReelSubject.value;
  }

  clearReel(): void {
    this.currentReelSubject.next(null);
  }
}
